const GridType = {
  FEED_IN_IMPORT: 'feedInImport',
  FEED_IN: 'feedIn',
  IMPORT: 'import',
  NONE: 'none',
};

export default GridType;
